// MODEL : FieldFilter
//
define('app/dashboard/DashboardFilterView',['require','glu/itemView','app/filters/FieldFilterView','hbs!./DashboardFilterView.hbs'],function(require) {

	'use strict';
	var ItemView = require('glu/itemView'),
		FieldFilterView = require('app/filters/FieldFilterView');

	return ItemView.extend({

		template: require('hbs!./DashboardFilterView.hbs'),

		serializeData: function() {
			return this;
		},

		events: {
			'change .dashboard-filter-field': 'setFilterField'
		},

		initialize: function() {
			this.fieldFilterView = new FieldFilterView({
				model: this.model
			});

			if (this.options.domain) {
				this.listenTo(this.options.domain, 'masterfilterchange', this.onMasterFilterChange);
			}
		},

		onMasterFilterChange: function() {
			this.options.dashboard.trigger('masterfilterchange', this.options.domain);
		},

		onClose: function() {
			this.fieldFilterView.close();
		},

		onRender: function() {
			this.$('.dashboard-filter-field').comboBox({
				width: 200
			});
			this.$el.append(this.fieldFilterView.render().el);
			this.$el.find('select.filter-selection option:contains(is null)').remove();
			this.$el.find('select.filter-selection option:contains(is not null)').remove();
		},

		fieldValue: function() {
			return this.model.getField() ? this.model.getField().id : '';
		},

		setFilterField: function() {
			var id = this.$('select.dashboard-filter-field').val();
			this.model.setField(this.options.fieldCollection.get(id));
		}


	});
});

